export enum PreferencesSurveySource {
    ONBOARDING = 1,
    AFTER_LEAD = 2,
    PREFERENCES = 3,
    CRM = 4,
    HOME_MATCH = 5
}
export enum PreferencesSurveySource {
    ONBOARDING = 1,
    AFTER_LEAD = 2,
    PREFERENCES = 3,
    CRM = 4,
    HOME_MATCH = 5
}
